import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MORE } from 'constants/shared/routes';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import Settings from '../presentational/Settings';

import { toggleTheme } from 'actions/isDarkModeEnabled';
import useLocalStorage from 'utils/hooks/useLocalStorage';
import { getTheme } from 'selectors/darkMode';
import useUpdateLanguage from '../hooks/useUpdateLanguage';
import useTranslate from 'lib/languages/useTranslate';

const SettingsContainer: FC = () => {
    const dispatch = useDispatch();
    const [language, onLanguageChange] = useUpdateLanguage();
    const [, setIsDarkModeEnabledLocal] = useLocalStorage(
        'isDarkModeEnabled',
        {},
    );
    const isDarkModeEnabled = useSelector(getTheme);
    const translate = useTranslate('appSettings');

    const onDarkModeToggle = (isEnabled: boolean) => {
        setIsDarkModeEnabledLocal(isEnabled);
        dispatch(toggleTheme(isEnabled));
    };

    return (
        <PageContainer className="more-settings-container">
            <SectionTitle title={translate('settings')} backRoute={MORE} />
            <Settings
                isDarkModeEnabled={isDarkModeEnabled as boolean}
                onDarkModeToggle={onDarkModeToggle}
                selectedLanguage={language}
                onLanguageChange={onLanguageChange}
            />
        </PageContainer>
    );
};

export default SettingsContainer;
